import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TilesComponent } from './tiles/tiles.component';
import { TileComponent } from './tile/tile.component';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { SemesterPipe } from './pipes/semester/semester.pipe';
import { ValidFromPipe } from './pipes/valid-from/valid-from.pipe';
import { ValidUntilPipe } from './pipes/valid-until/valid-until.pipe';
import { PhonenumberPipe } from './pipes/phonenumber/phonenumber.pipe';
import { LocalizedStringPipe } from '../localized-string.pipe';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { CardOverlayComponent } from './card-overlay/card-overlay.component';
import { CoordinatePipe } from './pipes/coordinate.pipe';
import { WeatherComponent } from './weather/weather.component';
import { QrCodeScannerComponent } from './qr-code-scanner/qr-code-scanner.component';
import { HumanizedDatePipe } from './pipes/humanized-date.pipe';

@NgModule({
    imports: [CommonModule, RouterModule, IonicModule, ReactiveFormsModule, TilesComponent,
        TileComponent,
        SemesterPipe,
        ValidFromPipe,
        ValidUntilPipe,
        PhonenumberPipe,
        LocalizedStringPipe,
        CoordinatePipe,
        ContactDetailsComponent,
        QrCodeComponent,
        CardOverlayComponent,
        WeatherComponent,
        QrCodeScannerComponent,
        HumanizedDatePipe],
    exports: [
        TilesComponent,
        TileComponent,
        SemesterPipe,
        ValidFromPipe,
        ValidUntilPipe,
        PhonenumberPipe,
        LocalizedStringPipe,
        CoordinatePipe,
        ContactDetailsComponent,
        QrCodeComponent,
        CardOverlayComponent,
        WeatherComponent,
        QrCodeScannerComponent,
        HumanizedDatePipe
    ]
})
export class ComponentsModule {}
